import Axios from '@/util/Axios'
import qs from 'qs';

export default {
  state: {
    email_loading:false,
    email_folders: null,
    slide_folder_accounts:[],
  },
  mutations:{
    set_email_loading(state,n){
      state.email_folders = n;
    },
    set_email_folders(state, n) {
      state.email_folders = n;
    },
    set_slide_folder_accounts(state, n) {
      state.slide_folder_accounts = [n];
    },
  },
  actions:{
    get_email_folders(context, n) {
      context.commit('set_email_loading', true);
      Axios.post('/v1/pri/store-email/folders', {})
        .then(function (response) {
          var res = response.data;
          context.commit('set_email_loading', false);
          if (res.code == 1 && res.data.length > 0) {
            res.data[0].checked_label_id = "INBOX"
            context.commit('set_email_folders', res.data);
            context.commit('set_slide_folder_accounts', res.data[0].display_name);
            if (n && n.hasOwnProperty('callback')) { 
              n.callback({label_id:res.data[0].checked_label_id, mailbox_email:res.data[0].mailbox_email})
            }
          }
        })
    },
  }


}



// WEBPACK FOOTER //
// ./src/vuex/modules/email/index.js